const regexp = {
  mobile: mobile => {
    let reg = new RegExp(/^1[345678]\d{9}$/);

    return reg.test(mobile);
  },
  email: email => {
    let reg = new RegExp(
      /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
      "g"
    );

    return reg.test(email);
  },
  password: password => {
    var reg = new RegExp(
      /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/,
      "g"
    );

    return reg.test(password);
  },
  //中文 
  chinese: chinese => {
    var reg = new RegExp(
      /[\u4E00-\u9FA5\uF900-\uFA2D]/,
      "g"
    );

    return reg.test(chinese);
  },
};

export default regexp;